import axios from "axios";
import qs from "qs"
import store from "@/store"
import router from "@/router"
import { getToken, removeToken, refreshesToken } from "@/assets/js/modules/auth"
import { getRemember } from "./utils"
import Warn from "@/assets/js/modules/warn"
import Vue from 'vue'
Vue.prototype.$warn = Warn.install;
let isLock = true;
// create an axios instance
const service = axios.create({
  baseURL: process.env.BASE_API, // api 的 base_url
  paramsSerializer: function (params) {
    var args = qs.stringify(params, {
      arrayFormat: 'indices',
      skipNulls: true
    });
    return args;
  },
  timeout: 60000, // request timeout
});

// request interceptor
service.interceptors.request.use(
  config => {
    if (store.getters.Token) {
      config.headers['Authorization'] = "Bearer " + getToken();
    } else {
      localStorage.removeItem('userInfo');
    }
    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);
// response interceptor
service.interceptors.response.use(
  // response => response,
  /**
   * 下面的注释为通过在response里，自定义code来标示请求状态
   * 当code返回如下情况则说明权限有问题，登出并返回到登录页
   * 如想通过 xmlhttprequest 来状态码标识 逻辑可写在下面error中
   * 以下代码均为样例，请结合自生需求加以修改，若不需要，则可删除
   */
  response => {
    const res = response.data;
    if (res.Code === 1) {
      return response;
    } else if (res.Code === -3) { //数据为空
      return Promise.reject(res.Message);
    } else if (res.Code === -1002) {
      return response;
    } else {
      Warn.install({
        warnText: res.Message,
        isShow: true,
      });
      return Promise.reject(res.Message);
    }

  },
  async (error) => {
    if (error && error.response) {
      if (error.response.status === 401) {
        if (getToken() != 'undefined' && getToken() && isLock && getRemember()) {
          const isRefreshToken = await refreshesToken();
          if (isRefreshToken) {
            isLock = false;   //防止并发造成死循环
            error.config.headers.Authorization = "Bearer " + getToken();
            const result = await axios.request(error.config); //一定要同步返回结果
            if (result) {
              isLock = true;
              return result;
            }
          } else {  //身份过期,重新登录
            removeToken();
            localStorage.removeItem('userInfo');
            router.push({
              path: '/login',
              query: { redirect: router.currentRoute.fullPath }//登录成功后跳入浏览的当前页面
            });
          }
        } else {  //token清除
          removeToken();
          localStorage.removeItem('userInfo');
          router.push({
            path: '/login',
            query: { redirect: router.currentRoute.fullPath }//登录成功后跳入浏览的当前页面
          })
        }
      } else if (error.response.status === 403) {
        Warn.install({
          warnText: "您的账户没有权限，熊出没相关资料需24级以上账户方可下载!",
          isShow: true,
        });
      }
    }
    console.log("err" + error); // for debug
    return Promise.reject(error);
  }
);

export default service;



// WEBPACK FOOTER //
// ./src/assets/js/modules/request.js